/**
 * Operator-only listing metadata flag (Sharetribe Console).
 * When true: hidden from homepage & search cards; shown on map with inverted title pin.
 */
export const isExclusiveMapPin = listing => {
  return listing?.attributes?.metadata?.exclusiveMapPin === true;
};

export const filterOutExclusiveMapPins = listings => {
  if (!Array.isArray(listings)) {
    return [];
  }
  return listings.filter(listing => !isExclusiveMapPin(listing));
};
